const sixMonthMaxAge = 60 * 60 * 24 * 180;

export const cookieOptions = { maxAge: sixMonthMaxAge, path: '/' };
